/**
 * @generated SignedSource<<247131d79908e150d144b65bd18338c4>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b

import type { ConcreteRequest } from 'relay-runtime';
export type entityOperationsHelpersSpaceOperationsQuery$variables = {
  spaceKey: string;
};
export type entityOperationsHelpersSpaceOperationsQuery$data = {
  readonly space: {
    readonly id: string | null;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
      readonly targetType: string | null;
    } | null> | null;
  } | null;
};
export type entityOperationsHelpersSpaceOperationsQuery = {
  response: entityOperationsHelpersSpaceOperationsQuery$data;
  variables: entityOperationsHelpersSpaceOperationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "operation"
          },
          {
            "kind": "ScalarField",
            "name": "targetType"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "entityOperationsHelpersSpaceOperationsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "entityOperationsHelpersSpaceOperationsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "66373ccec9c74286b704fa866e6f85ed",
    "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
    "metadata": {},
    "name": "entityOperationsHelpersSpaceOperationsQuery",
    "operationKind": "query",
    "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
  }
};
})();

(node as any).hash = "cc953c6fb5811bde7a3b5ed25712839f";

export default node;
